/**------------- Contacts constants -------------**/

/*  General  */
export const CONTACTS_LAYOUT_CLASS_NAME = "contacts-layout";
export const CONTACTS_CONTENT_CLASS_NAME =
	"contacts-content";
export const CONTACTS_FOOTER_CLASS_NAME = "contacts-footer";
